


// 获取当前日期 yyyy-mm-dd
export function getTodayDate(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 获取当前年份
export function getNowYear(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  return `${year}`;
}

// 获取现在季度
export function getNowQuarter(){
  let nowQuarter = '';
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  if(month === '01' || month === '02' || month === '03'){
    nowQuarter = '1';
  }else if(month === '04' || month === '05' || month === '06'){
    nowQuarter = '2';
  }else if(month === '07' || month === '08' || month === '09'){
    nowQuarter = '3';
  }else if(month === '10' || month === '11' || month === '12'){
    nowQuarter = '4';
  }
  return nowQuarter;
}


// 获取当年第一天
export function getYearFirstDay(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  return `${year}-01-01`;
}

// 获取本季度的第一天
export function getNowQuarterFirstDay(){
  let firstDay = "";
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  if(month === '01' || month === '02' || month === '03'){
    firstDay = year + '-01-01';
  }else if(month === '04' || month === '05' || month === '06'){
    firstDay = year + '-04-01';
  }else if(month === '07' || month === '08' || month === '09'){
    firstDay = year + '-07-01';
  }else if(month === '10' || month === '11' || month === '12'){
    firstDay = year + '-10-01';
  }
  return firstDay;

}

// 获取本季度的最后一天
export function getNowQuarterLastDay(){
  let lastDay = "";
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  if(month === '01' || month === '02' || month === '03'){
    lastDay = year + '-03-31';
  }else if(month === '04' || month === '05' || month === '06'){
    lastDay = year + '-06-30';
  }else if(month === '07' || month === '08' || month === '09'){
    lastDay = year + '-09-30';
  }else if(month === '10' || month === '11' || month === '12'){
    lastDay = year + '-12-31';
  }
  return lastDay;

}


// 获取30天前日期 yyyy-mm-dd
export function getThirtyDaysAgo(){
  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
  const oneMonthAgoYear = oneMonthAgo.getFullYear();
  const oneMonthAgoMonth = String(oneMonthAgo.getMonth() + 1).padStart(2, '0');
  const oneMonthAgoDay = String(oneMonthAgo.getDate()).padStart(2, '0');
  return `${oneMonthAgoYear}-${oneMonthAgoMonth}-${oneMonthAgoDay}`;
}


// 获取7天前日期 yyyy-mm-dd
export function getSevenDaysAgo(){
  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 7);
  const oneMonthAgoYear = oneMonthAgo.getFullYear();
  const oneMonthAgoMonth = String(oneMonthAgo.getMonth() + 1).padStart(2, '0');
  const oneMonthAgoDay = String(oneMonthAgo.getDate()).padStart(2, '0');
  return `${oneMonthAgoYear}-${oneMonthAgoMonth}-${oneMonthAgoDay}`;
}


// 获取30天前日期 yyyy-mm-dd
export function getAfterDay(day){
  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() + day);
  const oneMonthAgoYear = oneMonthAgo.getFullYear();
  const oneMonthAgoMonth = String(oneMonthAgo.getMonth() + 1).padStart(2, '0');
  const oneMonthAgoDay = String(oneMonthAgo.getDate()).padStart(2, '0');
  return `${oneMonthAgoYear}-${oneMonthAgoMonth}-${oneMonthAgoDay}`;
}

// 获取今年的区间日期段（年初到今天）
export function getNowYearRange(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  let dateArr = [];
  dateArr.push(`${year}-01-01`);
  dateArr.push(`${year}-${month}-${day}`);
  return dateArr;

}

// 获取本月的区间日期段（年初到今天）
export function getNowMonthRange(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  let dateArr = [];
  dateArr.push(`${year}-${month}-01`);
  dateArr.push(`${year}-${month}-${day}`);
  return dateArr;

}


// 获取下个月的最后一天
export function getNextMonthEnd(){
  let currentDate = new Date();  // 获取当前日期
  currentDate.setMonth(currentDate.getMonth() + 2);  // 增加一个月
  currentDate.setDate(1); // 设置日期为下个月的第一天
  currentDate.setDate(currentDate.getDate() - 1); // 减去一天以获取上个月的最后一天
  let year = currentDate.getFullYear();  // 获取年份
  let month = currentDate.getMonth() + 1; // 月份从0开始，所以要加1
  let lastDayOfMonth = currentDate.getDate();  // 获取最后一天的日期
  return `${year}-${month}-${lastDayOfMonth}`;

}

export function addYears(dateStr, years) {
  const date = new Date(dateStr);
  date.setFullYear(date.getFullYear() + years);
  return date.toISOString().split('T')[0];
}
//dateStr n年后的前一天日期
export function addYearsAndMinusOneDay(dateStr, years) {
  const date = new Date(dateStr);
  date.setFullYear(date.getFullYear() + years);
  date.setDate(date.getDate() - 1);
  return date.toISOString().split('T')[0];
}

// 日期格式化 yyyy-mm-dd
export function dateFormat(dateStr){
  if(!dateStr) return "";
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}


// 比对日期（字符串）
export function compareDate(date1, date2){
  const nowDate1 = new Date(date1);
  const nowDate2 = new Date(date2);
  if (nowDate1 >= nowDate2) {
    return true;
  } else {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/utils/common/DateUtils.js